module.exports = "<div class=\"igx-scroll\"\n     #scroll>\n    <div class=\"igx-scroll__viewport\" [ngStyle]=\"{ 'height': totalHeight }\"\n         (pan)=\"onPan($event)\"\n         (wheel)=\"onMouseWheel($event)\">\n        <ng-content>\n        </ng-content>\n    </div>\n    <div (scroll)=\"onScrolled($event)\"\n         #verticalScroll class=\"igx-scroll__vertical\" [ngStyle]=\"{ 'height': totalHeight }\">\n        <div [ngStyle]=\"{ 'height': innerHeight }\">\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scroll/scroll.component.html
// module id = 142
// module chunks = 0 1